<template>
  <v-form ref="formConta" v-model="contaValid" lazy-validation class="mt-4">
    <v-card class="mt-4">
      <v-card-title>
        <strong>Preencha os dados da conta</strong>
      </v-card-title>
      <v-card-text>
        <v-divider></v-divider>
        <v-container grid-list-md>
          <v-layout wrap>
            <v-flex xs12 md6>
              <v-autocomplete
                :disabled="isUpdating"
                v-model="bancoSelecionado"
                :items="bancos"
                :filter="filtrarObjetos"
                :rules="[validacao.conta_idBanco == false || validacao.conta_idBanco, (value) => (!!value && !!value.id) || 'Obrigatório.']"
                hint="Obrigatório"
                label="Selecione o Banco"
                item-text="nome"
                item-value="id"
                no-data-text
                autocomplete="disabled"
                :name="Math.random()"
                return-object
                @change="validacao.conta_idBanco = false"
              ></v-autocomplete>
            </v-flex>
            <v-flex xs12 md2>
              <v-text-field
                :disabled="isUpdating"
                v-model="conta.agencia"
                label="Agência"
                v-mask="'####'"
                hint="Sem o dígito"
                :rules="[
                  validacao.conta_agencia == false || validacao.conta_agencia,
                  (value) => !!value || 'Obrigatório.',
                  (value) => (value && value.length == 4) || 'Deve conter 4 dígitos numéricos'
                ]"
                color="blue-grey lighten-2"
                autocomplete="disabled"
                :name="Math.random()"
                @change="validacao.conta_agencia = false"
              ></v-text-field>
            </v-flex>
            <v-flex xs12 md4>
              <v-text-field
                :disabled="isUpdating"
                v-model="conta.numero"
                label="Conta"
                v-mask="'################'"
                hint="Com o dígito"
                persistent-hint
                :rules="[validacao.conta_numero == false || validacao.conta_numero, (value) => !!value || 'Obrigatório.', (value) => valida_conta(value)]"
                color="blue-grey lighten-2"
                autocomplete="disabled"
                :name="Math.random()"
                @change="validacao.conta_numero = false"
              ></v-text-field>
            </v-flex>
          </v-layout>
        </v-container>
      </v-card-text>
    </v-card>
  </v-form>
</template>

<script>
import { api } from "@/services/api.js";
import util from "../util";
export default {
  props: {
    validacao: {},
    isUpdating: { type: Boolean, default: false }
  },
  data() {
    return {
      conta: {},

      bancoSelecionado: {},
      bancos: [],

      contaValid: true
    };
  },
  methods: {
    async carregarBancos() {
      this.bancos = [];
      try {
        const response = await api.get("/ass/paywall/bancos");
        this.bancos = response.data;
      } catch (e) {
        this.mensagemErro =
          "ERRO: " +
          (e.toString().includes("status code 400")
            ? "SESSÃO EXPIRADA"
            : e.response && e.response.data && e.response.data.length > 0
            ? e.response.data[0].mensagem
            : "Indeterminado, verifique sua conexão");
      }
    },

    valida_conta(value) {
      var retorno = true;
      if (this.bancoSelecionado.id && value) {
        if (this.bancoSelecionado.numero == "001") {
          if (value.length > 14) {
            retorno = "Deve conter até 14 dígitos numéricos";
          }
        } else if (this.bancoSelecionado.numero == "104") {
          if (value.length < 12) {
            retorno = "Deve conter pelo menos 12 dígitos numéricos";
          }
        } else if (this.bancoSelecionado.numero == "033") {
          if (value.length != 9) {
            retorno = "Deve conter 9 dígitos numéricos";
          }
        } else if (this.bancoSelecionado.numero == "041") {
          if (value.length != 10) {
            retorno = "Deve conter 10 dígitos numéricos";
          }
        } else if (this.bancoSelecionado.numero == "237") {
          if (value.length < 6 || value.length > 8) {
            retorno = "Deve conter de 6 a 8 dígitos numéricos";
          }
        } else if (this.bancoSelecionado.numero == "748") {
          if (value.length != 6) {
            retorno = "Deve conter 6 dígitos numéricos";
          }
        } else if (value.length < 3) {
          retorno = "Deve conter pelo menos 3 dígitos numéricos";
        }
      }
      return retorno;
    },

    validar() {
      this.$refs.formConta.validate();
    },
    retornaConta() {
      if (!this.$refs.formConta.validate()) {
        return {};
      } else {
        if (this.bancoSelecionado.id) {
          this.conta.idBanco = this.bancoSelecionado.id;
          this.conta.banco = this.bancoSelecionado.numero;
          this.conta.nomeBanco = this.bancoSelecionado.nome;
        }

        return this.conta;
      }
    },
    filtrarObjetos(item, queryText, itemText) {
      return util.filtrarObjetos(item, queryText, itemText);
    }
  },

  async created() {
    await this.carregarBancos();
  }
};
</script>
